module.exports = __webpack_public_path__ + "img/glassquality_4.071ecfd4.png";